import { Pipe, PipeTransform } from '@angular/core';
import { ValueListItem } from '../valuelist/valuelist';


@Pipe({ name: 'valueListFilter' })
export class ValueListFilterPipe implements PipeTransform {
  transform(items: ValueListItem[], filter: any) {
    // filter items array, items which match and return true will be
    // kept, false will be filtered out
    return items.filter(item => item.key.indexOf(filter.key) !== -1);
  }
}
